import React from 'react';
import { useAccordionItem } from '../AccordionItemContext';

type Props = {
  children: JSX.Element | JSX.Element[] | string;
  className?: string;
};

export const AccordionContent = ({ children, className = '' }: Props) => {
  const { isOpen, contentId, buttonId } = useAccordionItem();

  // Render the accordion content always. The children are only rendered when isOpen is true.
  // this ensures the contentId refers to a valid DOM element for accessibility purposes.
  return (
    <div
      id={contentId}
      role="region"
      aria-labelledby={buttonId}
      className={className}
      hidden={!isOpen}
    >
      {isOpen && children}
    </div>
  );
};
